import React, { ReactElement, ReactNode } from 'react';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { Stack, StackProps, styled, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

interface SectionProps {
  title?: ReactNode | React.ElementType | ReactElement | JSX.Element | Element | string;
  titleAcessory?: ReactNode;
  defaultExpanded?: boolean;
  expanded?: boolean;
  rightView?: ReactNode;
}

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion defaultExpanded={false} disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderRadius: 0,
  border: 0,
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ExpandMore />} {...props} />
))(({ theme }) => ({
  '.MuiAccordionSummary-expandIconWrapper': {
    color: 'var(--color-greyscale-600)',
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const Section = (props: SectionProps & StackProps) => {
  const { title, defaultExpanded, expanded, children, titleAcessory, rightView, ...rest } = props;
  return (
    <Accordion defaultExpanded={defaultExpanded} expanded={expanded}>
      <AccordionSummary>
        {!!title ? (
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" alignItems="center" gap="16px">
              <Typography variant="subheading">{title}</Typography>
              {titleAcessory}
            </Stack>
            {rightView}
          </Stack>
        ) : null}
      </AccordionSummary>
      <AccordionDetails>
        <Stack {...rest}>{children}</Stack>
      </AccordionDetails>
    </Accordion>
  );
};
